import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import { isDoneResponse } from '../../../../../helpers/professional_my_page';
const DetailReplay = ({ order, showModalReplay }) => {
    const doneFirst = isDoneResponse(order);
    return (_jsx("div", Object.assign({ className: 'detail-reply align-center' }, { children: _jsx("button", Object.assign({ className: `btn ${doneFirst ? 'btn-tertiary' : 'btn-primary'} small modalBtn`, onClick: showModalReplay, onKeyDown: showModalReplay, type: 'button' }, { children: doneFirst ? '返信済' : '返信する' })) })));
};
DetailReplay.propTypes = {
    order: propShape().isRequired,
    showModalReplay: propFunc().isRequired,
};
export default DetailReplay;
